import ApplicantStageIndicator from 'ats/components/applicant-stage-indicator/ApplicantStageIndicator';
import HoverMenu from 'ats/components/hover-menu/HoverMenu';
import UserProfileAvatar from 'ats/components/user-profile-avatar/UserProfileAvatar';
import { applicantStore } from 'ats/pages/applicants/ApplicantStore';
import { ApplicantHistoryEdit } from 'ats/pages/applicants/components/ApplicantHistoryEdit';
import { modalStore } from 'components/layout/modals/ModalStore';
import moment from 'moment';
import React, { useState } from 'react';
import useIsClamped from 'ats/hooks/useIsClamped';
import { formatTimeAgo } from 'shared/utils';
import LinkifyText from 'ats/components/linkify-text/LinkifyText';

export default function HistoryCard({ history, onSuccess }) {
	const [showMore, setShowMore] = useState(false);
	const [descriptionRef, isClamped] = useIsClamped(
		history?.description,
		!showMore
	);

	const getApplicantStage = value =>
		applicantStore.stageOptions.find(stage => stage.value === value);

	const getApplicantStatus = value =>
		applicantStore.statusOptions.find(status => status.value === value);

	const applicantStageData = getApplicantStage(history?.newValue);
	const applicantStatusData = getApplicantStatus(
		applicantStore.stageToStatus[history?.newValue]
	);

	const handleHistoryEdit = history => {
		modalStore.openModal(
			{ title: 'Update History', size: 'xl', position: 'center' },
			<ApplicantHistoryEdit
				applicantId={history.applicant.id}
				history={history}
				handleSuccess={async () => {
					onSuccess?.();
				}}
			/>
		);
	};

	const getMenuItems = history => [
		{
			label: `${history?.description ? 'Edit' : 'Add'} Comment`,
			img: '/ats/icons/edit-icon.svg',
			onClick: () => handleHistoryEdit(history)
		}
	];

	return (
		<div className="applicant-history-card">
			<div className="history-card-info-container">
				<div className="history-card-applicant-info">
					<ApplicantStageIndicator
						stageLabel={applicantStageData?.label}
						statusLabel={applicantStatusData?.label}
						stageLevel={applicantStageData?.level}
						statusColor={applicantStatusData?.color}
					/>
					<h5>{applicantStageData?.label}</h5>
				</div>
				<div className="history-card-info actions">
					<span className="history-info-updated-by">
						<UserProfileAvatar
							imageUrl={history?.updatedBy?.imageUrl}
							name={history?.updatedBy?.name}
						/>
						{formatTimeAgo(new Date(history?.updatedAt), {
							moreThanOneDay: true
						})}
					</span>
					<HoverMenu
						id={history.id}
						position="left"
						buttonIcon={
							<img src="/ats/icons/three-dots-icon.svg" alt="Menu button" />
						}
						items={getMenuItems(history)}
					/>
				</div>
			</div>
			{history?.description && (
				<div className="history-card-description">
					<p
						ref={descriptionRef}
						className={showMore ? undefined : 'is-clamped'}>
						<LinkifyText text={history?.description} />
					</p>
					{showMore && history?.descriptionUpdatedBy?.id && (
						<div className="history-card-description-commented-by">
							Commented by
							<UserProfileAvatar
								imageUrl={history?.descriptionUpdatedBy?.imageUrl}
								name={history?.descriptionUpdatedBy?.name}
								showName
							/>{' '}
							at{' '}
							{moment().diff(
								moment(history?.descriptionUpdatedAt),
								'days',
								true
							) > 1
								? moment(history?.descriptionUpdatedAt).format('lll')
								: formatTimeAgo(new Date(history?.descriptionUpdatedAt))}
						</div>
					)}
					{(showMore || isClamped) && (
						<button onClick={() => setShowMore(!showMore)}>
							{showMore ? 'View Less' : 'View More'}
						</button>
					)}
				</div>
			)}
		</div>
	);
}
